import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import { flatMap } from 'lodash';
import Tags from 'bundles/tags/tags';
import { isBlank } from 'helpers/string_helpers';

import DatabaseField from './database_field';

const getTagsPathForDatabase = (databaseId) => {
  if (isBlank(databaseId)) {
    return null;
  } else {
    return `/database_settings/${databaseId}/tags`;
  }
};

export class DatabaseForms extends React.Component {
  static propTypes = {
    availableDatabases: PropTypes.array,
    classSlug: PropTypes.string.isRequired,
    databaseFieldProps: PropTypes.object,
    domNodes: PropTypes.shape({
      databaseFieldElement: PropTypes.object,
      tagsFormElement: PropTypes.object
    }),
    initialDatabaseId: PropTypes.number,
    isNewRecord: PropTypes.bool,
    paths: PropTypes.object,
    renderDatabaseForm: PropTypes.bool.isRequired,
    tags: PropTypes.array
  };

  state = {
    canManageTags: this.getCanManageTags(this.props.initialDatabaseId),
    databaseId: this.props.initialDatabaseId,
    paths: {
      ...this.props.paths,
      tags: this.props.isNewRecord ? getTagsPathForDatabase(this.props.initialDatabaseId) : this.props.paths.tags
    },
    tagIds: {},
    tags: this.props.tags
  };

  getAllDatabaseOptions() {
    return flatMap(this.props.availableDatabases, databaseGroup => databaseGroup.options);
  }

  getCanManageTags(databaseId) {
    if (isBlank(databaseId))  return false;

    const database = this.getAllDatabaseOptions().find(option => option.value === databaseId);
    return !isBlank(database) && database.canManageTags;
  }

  handleDatabaseChange = (databaseId) => {
    const path = getTagsPathForDatabase(databaseId);

    this.setState({
      canManageTags: this.getCanManageTags(databaseId),
      databaseId: databaseId,
      paths: { tags: path },
      tagIds: {},
      tags: []
    });
  };

  handleAddTag = (tag) => {
    const { tagIds, tags } = this.state;

    if (!tags.includes(tag.name)) {
      const newIds = tagIds;
      newIds[tag.name] = tag.id;

      this.setState(state => ({
        tagIds: newIds,
        tags: [...state.tags, tag.name]
      }));
    }
  };

  handleRemoveTag = (tag) => {
    const { tagIds, tags } = this.state;
    const filteredTags = tags.filter(stateTag => stateTag !== tag);
    const newIds = _.omit(tagIds, tag);

    this.setState({
      tagIds: newIds,
      tags: filteredTags
    }); 
  };

  render() {
    const { paths } = this.state;

    return (
      <React.Fragment>
        {this.renderDatabaseFields()}
        {paths.tags && this.renderTagsForm()}
      </React.Fragment>
    );
  }

  renderDatabaseFields = () => {
    const { availableDatabases, classSlug, renderDatabaseForm } = this.props;
    const { databaseId } = this.state;

    if (renderDatabaseForm) {
      return ReactDOM.createPortal(
        <DatabaseField
          availableDatabases={availableDatabases}
          classSlug={classSlug}
          databaseId={databaseId}
          onDatabaseChange={this.handleDatabaseChange}
        />,
        this.props.domNodes.databaseFieldElement
      );
    }
  };

  renderTagsForm = () => {
    const { classSlug, isNewRecord } = this.props;
    const { canManageTags, databaseId, paths, tagIds, tags } = this.state;

    return ReactDOM.createPortal(
      <Tags
        canManageTags={canManageTags}
        classSlug={classSlug}
        databaseId={databaseId}
        isNewRecord={isNewRecord}
        paths={paths}
        tagIds={tagIds}
        tags={tags}
        onAddTag={this.handleAddTag}
        onRemoveTag={this.handleRemoveTag}
      />,
      this.props.domNodes.tagsFormElement
    );
  };
}

export default class DatabaseFormsWrapper extends React.Component {
  static propTypes = {
    domIds: PropTypes.shape({
      databaseField: PropTypes.string.isRequired,
      tagsForm: PropTypes.string.isRequired
    })
  };

  domNodes = {
    databaseFieldElement: document.getElementById(this.props.domIds.databaseField),
    tagsFormElement: document.getElementById(this.props.domIds.tagsForm)
  };

  render() {
    const { domIds, ...props } = this.props;
    return (
      <DatabaseForms
        {...props}
        domNodes={this.domNodes}
      />
    );
  }
}
